import type { LucideIcon } from "lucide-react";
import { TabButton } from "@/components/ui/pressable";
import { cn } from "@/lib/utils";

export type ViewTab<T extends string> = {
  value: T;
  label: string;
  icon?: LucideIcon;
};

/** Underlined view switcher (List · Board · Types). */
export const ViewTabs = <T extends string>({
  value,
  onChange,
  tabs,
  className,
  ariaLabel = "View",
}: {
  value: T;
  onChange: (next: T) => void;
  tabs: ViewTab<T>[];
  className?: string;
  ariaLabel?: string;
}) => (
  <div
    role="tablist"
    aria-label={ariaLabel}
    className={cn("flex h-8 shrink-0 items-stretch gap-1", className)}
  >
    {tabs.map((tab) => {
      const Icon = tab.icon;
      return (
        <TabButton
          key={tab.value}
          role="tab"
          variant="underline"
          selected={tab.value === value}
          onClick={() => onChange(tab.value)}
          className={cn("h-8 px-1.5", tab.value === value && "text-primary")}
        >
          {Icon ? <Icon className="size-4" aria-hidden /> : null}
          {tab.label}
        </TabButton>
      );
    })}
  </div>
);
